// extracted by mini-css-extract-plugin
export default {"stepContainer":"ez7Czv","stepTitle":"xloWKc","stepDescription":"pn4pme"};